// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"190":"docs","191":"oxc-home","208":"oxc-me"}[chunkId] + "." + {"190":"48dd4358","191":"af503ff5","208":"c81d95ba"}[chunkId] + ".css";
};